import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { bootstrapTelegramUI } from './auth/telegram'
import './i18n'
import './index.css'
import './polish.css'
import './folded-veil.css'
import './lobby-shell.css'
import './snowfold-village.css'
import './reference-layout.css'
import './lobby-background.css'
import './ux-resilience.css'
import App from './App'

// Expand + sync header before first paint when Telegram injects WebApp early.
bootstrapTelegramUI()

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
